module.exports = __webpack_public_path__ + "img/cooperation07.888c47e1.png";